import { createStore, createHook, type StoreActionApi } from 'react-sweet-state';
import { HEADER_X2C_NUDGE_STEP } from '../../common/constants';
import type { NUDGE_STEP } from '../../common/types';

type State = {
	nudgeStep: NUDGE_STEP;
};

const setNudgeStep =
	(nudgeStep: NUDGE_STEP) =>
	({ setState }: StoreActionApi<State>) => {
		setState({ nudgeStep });
	};

const actions = {
	setNudgeStep,
};

type Actions = typeof actions;

const Store = createStore<State, Actions>({
	initialState: { nudgeStep: HEADER_X2C_NUDGE_STEP },
	actions,
	name: 'X2COnboardingNudgeStepStore',
});

export const useX2CNudgeStep = createHook(Store);
